import { useState } from 'react';
import Button from '../Button';
import Checkbox from '../Checkbox';
import { useConsent } from '../../contexts/ConsentContext';
import type { CookieBannerProps } from './CookieBanner.types';
import './CookieBanner.scss';

export default function CookieBanner({ className }: CookieBannerProps) {
  const { decided, acceptAll, essentialsOnly, save } = useConsent();
  const [customize, setCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  if (decided) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookies"
      aria-describedby="cookie-banner-desc"
      className={['cookie-banner', className || ''].filter(Boolean).join(' ')}
    >
      <div className="cookie-banner__inner">
        <p id="cookie-banner-desc" className="cookie-banner__text">
          Мы используем cookies для работы сайта, аналитики и маркетинга. Вы можете выбрать категории.
        </p>
        {customize ? (
          <div className="cookie-banner__options">
            <Checkbox label="Essential" description="Необходимы для работы" checked disabled />
            <Checkbox label="Analytics" description="Помогает улучшать сайт" checked={analytics} onChange={e => setAnalytics(e.target.checked)} />
            <Checkbox label="Marketing" description="Персональные предложения" checked={marketing} onChange={e => setMarketing(e.target.checked)} />
          </div>
        ) : null}
        <div className="cookie-banner__actions">
          {customize ? (
            <Button variant="primary" onClick={() => save({ analytics, marketing })}>Сохранить</Button>
          ) : (
            <Button variant="primary" onClick={acceptAll}>Accept all</Button>
          )}
          <Button variant="secondary" onClick={essentialsOnly}>Essentials only</Button>
          {!customize ? (
            <Button variant="ghost" onClick={() => setCustomize(true)}>Customize</Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
